var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.titleTxt } },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticClass: "formBox",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.VRDate"),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.ptInfo.planTaskDate,
                          format: "yyyy-MM-DD",
                          valueformat: "yyyyMMDD",
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.ptInfo, "planTaskDate", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.participants"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.visitParam.participant,
                          maxlength: 60,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "participant",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.canEdit
                ? _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeVisitReport.VRForm.startTime"),
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: {
                              val: _vm.ptInfo.planTaskStartTime,
                              disabled: "",
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.ptInfo,
                                  "planTaskStartTime",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeVisitReport.VRForm.endTime"),
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: {
                              val: _vm.ptInfo.planTaskEndTime,
                              disabled: "",
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.ptInfo,
                                  "planTaskEndTime",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : [
                    _c("RangePick", {
                      staticClass: "rangePickerBox",
                      attrs: {
                        "target-form": _vm.form,
                        "key-list": ["planTaskStartTime", "planTaskEndTime"],
                        "plan-task-date": _vm.ptInfo.planTaskDate,
                        "actual-plan-task-flag": _vm.ptInfo.actualPlanTaskFlag,
                        ptpk: _vm.ptInfo.planTaskInfoPk,
                        "start-label": _vm.$t(
                          "storeVisitReport.VRForm.startTime"
                        ),
                        "end-label": _vm.$t("storeVisitReport.VRForm.endTime"),
                        inline: "",
                      },
                    }),
                  ],
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.visitPurposeOne",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.destination1"),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.visitParam.visitPurposeOne,
                          options: _vm.optConfig.visitPurposeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "visitPurposeOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.visitPurposeTwo",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.destination2"),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.visitParam.visitPurposeTwo,
                          options: _vm.optConfig.visitPurposeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "visitPurposeTwo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.topic1",
                        rules: _vm.rules.chooseEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.issue1"),
                      },
                    },
                    [
                      _vm.canEdit
                        ? _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.topic1,
                              options: _vm.optConfig.visitPurposeOptions,
                              "allow-create": "",
                              "value-key": "name",
                              maxlength: 150,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam,
                                  "topic1",
                                  $event
                                )
                              },
                            },
                          })
                        : _c("FormInput", {
                            attrs: {
                              val: _vm.formatVoptions(
                                _vm.form.visitParam.topic1
                              ),
                              disabled: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.detail1",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.detailDesc1"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.detail1,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "detail1",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.topic2",
                        rules: _vm.rules.chooseEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.issue2"),
                      },
                    },
                    [
                      _vm.canEdit
                        ? _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.topic2,
                              options: _vm.optConfig.visitPurposeOptions,
                              "allow-create": "",
                              "value-key": "name",
                              maxlength: 150,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam,
                                  "topic2",
                                  $event
                                )
                              },
                            },
                          })
                        : _c("FormInput", {
                            attrs: {
                              val: _vm.formatVoptions(
                                _vm.form.visitParam.topic2
                              ),
                              disabled: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "visitParam.detail2",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.VRForm.detailDesc2"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.detail2,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "detail2",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.issue3"),
                      },
                    },
                    [
                      _vm.canEdit
                        ? _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.topic3,
                              options: _vm.optConfig.visitPurposeOptions,
                              "allow-create": "",
                              "value-key": "name",
                              maxlength: 150,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam,
                                  "topic3",
                                  $event
                                )
                              },
                            },
                          })
                        : _c("FormInput", {
                            attrs: {
                              val: _vm.formatVoptions(
                                _vm.form.visitParam.topic3
                              ),
                              disabled: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.detailDesc3"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.detail3,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "detail3",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.issue4"),
                      },
                    },
                    [
                      _vm.canEdit
                        ? _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.topic4,
                              options: _vm.optConfig.visitPurposeOptions,
                              "allow-create": "",
                              "value-key": "name",
                              maxlength: 150,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam,
                                  "topic4",
                                  $event
                                )
                              },
                            },
                          })
                        : _c("FormInput", {
                            attrs: {
                              val: _vm.formatVoptions(
                                _vm.form.visitParam.topic4
                              ),
                              disabled: "",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.detailDesc4"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.detail4,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "detail4",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.followMatter1"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.followUpAction1,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpAction1",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.VRForm.followDeadline1"
                        ),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.visitParam.followUpDate1,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpDate1",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.followMatter2"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.followUpAction2,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpAction2",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.VRForm.followDeadline2"
                        ),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.visitParam.followUpDate2,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpDate2",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "u-row" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.followMatter3"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.visitParam.followUpAction3,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpAction3",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.VRForm.followDeadline3"
                        ),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.visitParam.followUpDate3,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.visitParam,
                              "followUpDate3",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeVisitReport.VRForm.photoFile"),
                    required: "",
                  },
                },
                [
                  _c("FormUploadFile", {
                    attrs: {
                      "url-list": _vm.form.visitParam.photos,
                      accept: "image/*",
                      limit: 3,
                      "upload-params": _vm.uploadParams,
                      mode: _vm.mode,
                    },
                    on: {
                      "update:urlList": function ($event) {
                        return _vm.$set(_vm.form.visitParam, "photos", $event)
                      },
                      "update:url-list": function ($event) {
                        return _vm.$set(_vm.form.visitParam, "photos", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-checkbox-group" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-title",
                      attrs: {
                        label: _vm.$t("storeVisitReport.VRForm.others"),
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { disabled: !_vm.canEdit },
                          on: { change: _vm.onCheckListChange },
                          model: {
                            value: _vm.checkKeys,
                            callback: function ($$v) {
                              _vm.checkKeys = $$v
                            },
                            expression: "checkKeys",
                          },
                        },
                        _vm._l(
                          _vm.optConfig.VRCheckListOptions,
                          function (item) {
                            return _c(
                              "el-checkbox",
                              { key: item.code, attrs: { label: item.code } },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.visitParam.dynamicDataList != null &&
              _vm.feedbackCheckList.length > 0
                ? _c(
                    "div",
                    { staticClass: "form-checkbox-group" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-title",
                          attrs: {
                            label: _vm.$t("storeVisitReport.VRForm.feedback"),
                          },
                        },
                        [
                          _vm.feedbackCheckList[0]["redFlag"] == "Y"
                            ? _c("div", { staticClass: "show-tips" }, [
                                _vm._v("您有指派任务未执行"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: !_vm.canEdit },
                              on: { change: _vm.onCheckListChange2 },
                              model: {
                                value: _vm.form.visitParam.dynamicDataList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.visitParam,
                                    "dynamicDataList",
                                    $$v
                                  )
                                },
                                expression: "form.visitParam.dynamicDataList",
                              },
                            },
                            _vm._l(
                              _vm.feedbackCheckList,
                              function (item, index) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: index,
                                    attrs: { label: item.description },
                                  },
                                  [_vm._v(_vm._s(item.description))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.visitParam.dynamicDataList != null &&
              _vm.form.visitParam.dynamicDataList.length > 0 &&
              _vm.form.visitParam.dynamicDataList.indexOf("其他拜访任务") > -1
                ? _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "storeVisitReport.VRForm.feedback_other_task"
                            ),
                            required: "",
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: {
                              val: _vm.form.visitParam.otherTaskDescription,
                              disabled: !_vm.canEdit,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam,
                                  "otherTaskDescription",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isBailianFlag
        ? _c(
            "BoxWrap",
            {
              attrs: {
                title: _vm.$t("storeVisitReport.recordFeedback.subTitle1"),
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "dataForm2",
                  staticClass: "formBox",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    size: "small",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "visitParam.recordFeedback.acceptTerms",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.acceptTerms"
                            ),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.recordFeedback
                                .acceptTerms,
                              options: _vm.YorNOptions,
                              mode: _vm.mode,
                              clearable: false,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam.recordFeedback,
                                  "acceptTerms",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "visitParam.recordFeedback.willingToRtmOrder",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.willingToRtmOrder"
                            ),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.form.visitParam.recordFeedback
                                .willingToRtmOrder,
                              options: _vm.YorNOptions,
                              mode: _vm.mode,
                              clearable: false,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.visitParam.recordFeedback,
                                  "willingToRtmOrder",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "visitParam.recordFeedback.urgentDeliveryTime",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.urgentDeliveryTime"
                            ),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.urgentDeliveryTimeVal,
                              options: _vm.optConfig.urgentDeliveryTimeOptions,
                              change: _vm.handleUrgentDeliveryTime,
                              mode: _vm.mode,
                              clearable: false,
                            },
                            on: {
                              "update:val": function ($event) {
                                _vm.urgentDeliveryTimeVal = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "visitParam.recordFeedback.regularDeliveryTime",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.regularDeliveryTime"
                            ),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.regularDeliveryTimeVal,
                              options: _vm.optConfig.regularDeliveryTimeOptions,
                              change: _vm.handleRegularDeliveryTime,
                              mode: _vm.mode,
                              clearable: false,
                            },
                            on: {
                              "update:val": function ($event) {
                                _vm.regularDeliveryTimeVal = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBailianFlag
        ? _c(
            "BoxWrap",
            {
              attrs: {
                title: _vm.$t("storeVisitReport.recordFeedback.subTitle2"),
              },
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "formBox",
                  attrs: { size: "small", "label-position": "top" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-evaluate-group" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-title",
                          attrs: {
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.evaluateRate"
                            ),
                            required: "",
                          },
                        },
                        [
                          _c("el-rate", {
                            attrs: {
                              max: 10,
                              colors: ["#004EA8", "#004EA8", "#004EA8"],
                              "show-score": true,
                              disabled: !_vm.canEdit,
                            },
                            on: { change: _vm.onEvaluate },
                            model: {
                              value: _vm.evaluateRate,
                              callback: function ($$v) {
                                _vm.evaluateRate = $$v
                              },
                              expression: "evaluateRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-checkbox-group" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-title",
                          attrs: {
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.goodContent"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: !_vm.canEdit },
                              on: { change: _vm.onGoodContentChange },
                              model: {
                                value: _vm.goodContentList,
                                callback: function ($$v) {
                                  _vm.goodContentList = $$v
                                },
                                expression: "goodContentList",
                              },
                            },
                            _vm._l(
                              _vm.optConfig.goodContentOptions,
                              function (item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.code,
                                    attrs: { label: item.code },
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-checkbox-group" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-title",
                          attrs: {
                            label: _vm.$t(
                              "storeVisitReport.recordFeedback.badContent"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: !_vm.canEdit },
                              on: { change: _vm.onBadContentChange },
                              model: {
                                value: _vm.badContentList,
                                callback: function ($$v) {
                                  _vm.badContentList = $$v
                                },
                                expression: "badContentList",
                              },
                            },
                            [
                              _vm._l(
                                _vm.optConfig.badContentOptions,
                                function (item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.code,
                                      attrs: { label: item.code },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: _vm.handleOtherContentSelected,
                                  },
                                  model: {
                                    value: _vm.isOtherContentSelected,
                                    callback: function ($$v) {
                                      _vm.isOtherContentSelected = $$v
                                    },
                                    expression: "isOtherContentSelected",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "storeVisitReport.recordFeedback.otherContent"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isOtherContentSelected
                    ? _c(
                        "div",
                        { staticClass: "u-row" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeVisitReport.recordFeedback.otherContent"
                                ),
                              },
                            },
                            [
                              _c("FormTextArea", {
                                attrs: {
                                  val: _vm.otherContentStr,
                                  maxlength: 150,
                                  mode: _vm.mode,
                                  change: _vm.handleotherContent,
                                },
                                on: {
                                  "update:val": function ($event) {
                                    _vm.otherContentStr = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-actions" },
        [
          _vm.mode === "edit"
            ? [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.onSaveDraft } },
                  [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.onSave },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.submit")))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }